import { createStyles, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, Typography } from '@nutrien/cxp-components';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .title': {
        marginTop: '16px',
        marginBottom: '24px',
      },
    },
    subTitle: {},
  }),
);

interface Props {
  open: boolean;
  onCancel: () => void;
  onDiscard: () => void;
  titleText?: string;
  continueEditingButtonText?: string;
  discardDraftButtonText?: string;
  areYouSureText?: string;
  cancelText?: string;
  maxHeight?: number;
  flipColors?: boolean;
  disableEnforceFocus?: boolean;
  disableActionButton?: boolean;
}

const DiscardDraftModal: React.FC<Props> = ({
  open,
  onCancel,
  onDiscard,
  titleText,
  continueEditingButtonText,
  discardDraftButtonText,
  areYouSureText,
  cancelText,
  maxHeight,
  flipColors = false,
  disableEnforceFocus = false,
  disableActionButton = false,
}) => {
  const classes = useStyles();
  const defaultTitleText = 'Discard draft';
  const defaultContinueEditingText = 'Continue editing';
  const defaultDiscardDraftHazardText = 'Discard draft';
  const defaultAreYouSure = 'Are you sure?';
  const defaultCancelText = 'Canceling will lose any information you have added.';
  const [isDiscarding, setIsDiscarding] = useState(false);

  useEffect(() => {
    if (open) {
      setIsDiscarding(false);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      titleText={titleText || defaultTitleText}
      backButton={false}
      disableEnforceFocus={disableEnforceFocus}
      dialogActions={
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xs={5}>
            <Button
              onClick={onCancel}
              variant="outlined"
              color={flipColors ? 'error' : 'primary'}
              noMinHeight
              disabled={isDiscarding}
            >
              {continueEditingButtonText || defaultContinueEditingText}
            </Button>
          </Grid>
          <Grid item xs={5}>
            <Button
              onClick={() => {
                setIsDiscarding(true);
                onDiscard();
              }}
              variant="contained"
              color={flipColors ? 'primary' : 'error'}
              noMinHeight
              isLoading={isDiscarding}
              disabled={disableActionButton}
            >
              {discardDraftButtonText || defaultDiscardDraftHazardText}
            </Button>
          </Grid>
        </Grid>
      }
      maxWidth="xs"
      maxHeight={maxHeight ? `${maxHeight}px` : '250px'}
      className={classes.root}
    >
      <Typography variant="h6" className="title">
        {areYouSureText || defaultAreYouSure}
      </Typography>
      <Typography variant="body1" className={classes.subTitle}>
        {cancelText || defaultCancelText}
      </Typography>
    </Dialog>
  );
};

export default DiscardDraftModal;
